import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { LoginPayload, LoginResponse, TanaqulUrlResponse } from '../models/login';

export const onLogin = async (data: LoginPayload) => {
	try {
		const response = await axios.post<JsonResponse<LoginResponse>>('login', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetTanaqulUrl = async () => {
	try {
		const response = await axios.get<JsonResponse<TanaqulUrlResponse>>('register/tanaqul-app-url');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
